import axios from 'axios';
import apiUrl from 'config/api';

import {
  USER_LOGIN,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_SIGN_UP,
  USER_SIGN_UP_SUCCESS,
  USER_SIGN_UP_FAIL,
  USER_PASSWORD_RESET,
  USER_PASSWORD_RESET_SUCCESS,
  USER_PASSWORD_RESET_FAIL,
  USER_PASSWORD_NEW,
  USER_PASSWORD_NEW_SUCCESS,
  USER_PASSWORD_NEW_FAIL,
  USER_CONFIRM,
  USER_CONFIRM_SUCCESS,
  USER_CONFIRM_FAIL,
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAIL,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL
} from 'config/types';

export const login = (values, {onSuccess}) => dispatch => {
  dispatch({ type: USER_LOGIN });

  return axios({
    method: 'post',
    url: `${apiUrl}/login`,
    data: { ...values },
  })
    .then(({ data }) => dispatch({ type: USER_LOGIN_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: USER_LOGIN_FAIL, error }));
};

export const logout = ({onSuccess}) => dispatch => {
  dispatch({ type: USER_LOGOUT });
  onSuccess();
};

export const signUp = (values, {onSuccess}) => dispatch => {
  dispatch({ type: USER_SIGN_UP });

  return axios({
    method: 'post',
    url: `${apiUrl}/sign-up`,
    data: { ...values },
  })
    .then(({ data }) => dispatch({ type: USER_SIGN_UP_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: USER_SIGN_UP_FAIL, error }));
};

export const resetPassword = (values, {onSuccess}) => dispatch => {
  dispatch({ type: USER_PASSWORD_RESET });

  return axios({
    method: 'post',
    url: `${apiUrl}/password/reset`,
    data: { ...values },
  })
    .then(({ data }) => dispatch({ type: USER_PASSWORD_RESET_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: USER_PASSWORD_RESET_FAIL, error }));
};

export const newPassword = (values, {onSuccess}) => dispatch => {
  dispatch({ type: USER_PASSWORD_NEW });

  return axios({
    method: 'post',
    url: `${apiUrl}/password/new`,
    data: { ...values },
  })
    .then(({ data }) => dispatch({ type: USER_PASSWORD_NEW_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: USER_PASSWORD_NEW_FAIL, error }));
};

export const confirmUser = (values, {onSuccess}) => dispatch => {
  dispatch({ type: USER_CONFIRM });

  return axios({
    method: 'post',
    url: `${apiUrl}/confirm`,
    data: { ...values },
  })
    .then(({ data }) => dispatch({ type: USER_CONFIRM_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: USER_CONFIRM_FAIL, error }));
};

export const loadUser = () => dispatch => {
  dispatch({ type: LOAD_USER });

  return axios({
    method: 'get',
    url: `${apiUrl}/user`
  })
    .then(({ data }) => dispatch({ type: LOAD_USER_SUCCESS, payload: data }))
    .catch(error => dispatch({ type: LOAD_USER_FAIL, error }));
};

export const updateProfile = (values, {onSuccess}) => dispatch => {
  dispatch({ type: UPDATE_PROFILE });

  return axios({
    method: 'patch',
    url: `${apiUrl}/profile`,
    data: { ...values },
  })
    .then(({ data }) => dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: UPDATE_PROFILE_FAIL, error }));
};